import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { APICallService } from 'src/app/services/api-call.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';

@Component({
  selector: 'hazard-grd-lov',
  templateUrl: './hazard-grd-lov.component.html',
  styleUrls: ['./hazard-grd-lov.component.css']
})
export class HazardGrdLovComponent implements OnInit {

  private hazardGrdModuleId: string = 'BMM105';
  private selectedData: any;
  public titleLov: string = "Hazard Grade".toUpperCase();

  hazardGrdTable: any = {
    cols: [
      {
        key: "HAZARD_GRD_CD",
        header: "Hazard Grade Code",
        dataType: "string"
      },
      {
        key: "HAZARD_GRD_DESC",
        header: "Hazard Grade Description",
        dataType: "string"
      },
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  };

  constructor(
    private jsonDataService: JsonDataService,
    private dialogRef: MatDialogRef<HazardGrdLovComponent>,
    private _api: APICallService,
    private securityService: SecurityService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    @Inject(MAT_DIALOG_DATA) public fromMainData: any,
  ) {
    this.getHazardGrdData();
  }

  ngOnInit(): void {
  }

  onRowClick(ev: any) {
    try {
      this.selectedData = ev;
    } catch (e) {
    console.error(e);

    }
  }

  private getHazardGrdData(): void {
    try {
      this.hazardGrdTable.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._api.getHazardGrade({
        lineCd: this.fromMainData.lineCd,
        moduleId: this.fromMainData.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, () => {
            this.securityService.hasValidCsrfToken(data, () => {
              let content = JSON.parse(this.jsonDataService.decrypt(data?.response));
              if (content.moduleId === this.hazardGrdModuleId) {
                this.jsonDataService.contorlLoading(false);
                this.hazardGrdTable.tblData = content.data.filter((e: any) => e.ACTIVE_TAG == 'A');
                this.hazardGrdTable.loading = false;
              } else {
                this.hazardGrdTable.loading = false;
                this.jsonDataService.contorlLoading(false);
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            });
          });
        },
        error: (e: any) => {
          this.securityService.checkRequestKeyResponse(e, () => {
            this.hazardGrdTable.loading = false;
            this.jsonDataService.contorlLoading(false);
            this.appMessageService.showAppMessage(e, "error");
          });
        }
      });
    }
    catch (e) {
    console.error(e);
      this.hazardGrdTable.loading = false;
      this.jsonDataService.contorlLoading(false);
    }
  }

  onClose(str: string) {
    try {
      if (this.selectedData == '' || this.selectedData == null) {
        this.dialogRef.close({ content: '', button: str });
      }
      else {
        this.dialogRef.close({ content: this.selectedData, button: str });
      }
    } catch (e) {
    console.error(e);

    }
  }

}
